export default __webpack_public_path__ + "static/media/K.2144975d.svg";